import React, { useEffect, useState } from "react";
import useSWR from "swr";

const fetcher = (...args) => fetch(...args).then((res) => res.json());

export default function CountySelector({}) {
  const [selectedState, setSelectedState] = useState(undefined);
  const [selectedCounty, setSelectedCounty] = useState(undefined);

  const { data, error, isLoading } = useSWR(
    `/api/v1/counties.json?state=${[selectedState].join("")}`,
    fetcher
  );

  if (isLoading) return null;
  if (error) return <div>Error</div>;

  return (
    <div className="w-full flex justify-between items-end gap-x-2">
      <div>
        <label className="text-sm">State</label>
        <select
          value={selectedState}
          onChange={(e) => setSelectedState(e.target.value)}
        >
          <option key="" value="">Select a state</option>
          {data &&
            data.states.map((state) => (
              <option key={state.abbreviation} value={state.abbreviation}>
                {state.name}
              </option>
            ))}
        </select>
      </div>
      <div className="grow">
        <label className="text-sm">County</label>
        <select
          value={selectedCounty}
          onChange={(e) => setSelectedCounty(e.target.value)}
          className="w-full"
        >
          <option key="" value="">Select a county</option>
          {data &&
            data.counties &&
            data.counties.map((county) => (
              <option key={county.id} value={county.permalink}>
                {county.name}
              </option>
            ))}
        </select>
      </div>
      <div>
        <button
          className="btn self-start"
          disabled={!selectedCounty}
          onClick={() => {
            window.location = selectedCounty;
          }}
        >
          Go
        </button>
      </div>
    </div>
  );
}
import renderer from "../shared/renderer";
renderer(CountySelector);
